import { z } from 'zod'

export const schema = z.object({})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  cottageUid: z.string(),
  bookmarkLists: z.array(z.number().int()),
  note: z.string().nullable().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
